import { ContextMenu } from "lib/@components/context-menu-bar"

export const TaskContextMenu = ContextMenu("task")
